export default "__VITE_ASSET__ecd1d772__"